import script from "./PageTemplate.vue?vue&type=script&setup=true&lang=ts&generic=ItemKey%20extends%20string"
export * from "./PageTemplate.vue?vue&type=script&setup=true&lang=ts&generic=ItemKey%20extends%20string"
/* custom blocks */
import block0 from "./PageTemplate.vue?vue&type=custom&index=0&blockType=i18n&lang=jsonc"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__